// @generated by codegen v0.0.0 with parameter "target=ts,service.creativefabrica.studiomediamatrix=VITE_RPC_STUDIOMEDIAMATRIX_URL,service.creativefabrica.studiofeed=VITE_RPC_STUDIOFEED_URL,service.creativefabrica.studiofeed=VITE_RPC_STUDIOFEED_URL,service.creativefabrica.imageprocessor=VITE_RPC_IMAGEPROCESSOR_URL,include.creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.FavoriteTool=mutation,include.creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.UnfavoriteTool=mutation,include.creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.ListFavoriteTools=query,include.creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.InitiateSession=mutation,include.creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.IterateSession=mutation,include.creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.ListSessions=infiniteQuery,include.creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.GetSession=query,include.creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.GetSessionIterations=infiniteQuery,include.creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.CreateShareLink=mutation,include.creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.DeleteSession=mutation,include.creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.GetSessionInputMedia=query,include.creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.GetSessionMedia=query,include.creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.SetSessionMediaNSFW=mutation,include.creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.PurgeSession=mutation,include.creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.UpdateSession=mutation,include.creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.DownloadBrandedMedia=mutation,include.creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.ListModels=query,include.creativefabrica.studiofeed.v1.TemplateService.ListTemplates=infiniteQuery,include.creativefabrica.studiofeed.v1.TemplateService.GetTemplate=query,include.creativefabrica.studiofeed.v1.FeedService.GetDiscoverFeed=infiniteQuery,include.creativefabrica.studiofeed.v1.FeedService.RecordAction=mutation,include.creativefabrica.studiofeed.v1.FeedService.ListUserLikedFeeds=infiniteQuery,include.creativefabrica.studiofeed.v1.FeedService.GetFeedByObjectID=query,include.creativefabrica.studiofeed.v1.FeedService.ListIsLikedByUser=query,include.creativefabrica.studiofeed.v1.FeedService.GetFeed=infiniteQuery,include.creativefabrica.studiofeed.v1.FeedService.PinFeedEntry=mutation,include.creativefabrica.studiofeed.v1.FeedService.UnpinFeedEntry=mutation,include.creativefabrica.studiofeed.v1.FeedService.ReportFeedEntry=mutation,include.creativefabrica.studiofeed.v1.FeedService.CreateReportAttachmentUploadUrl=mutation,include.creativefabrica.imageprocessor.v1.UpscalerService.UpscalerUpscale=mutation"
// @generated from file creativefabrica/studiomediamatrix/v1/service.proto (package creativefabrica.studiomediamatrix.v1, syntax proto3)
/* eslint-disable */

import type { InfiniteData, UseInfiniteQueryOptions, UseMutationOptions, UseQueryOptions } from "@tanstack/react-query";
import { useInfiniteQuery, useMutation, useQuery } from "@tanstack/react-query";
import { createClient } from "@connectrpc/connect";
import { createConnectTransport } from "@connectrpc/connect-web";
import type { MessageInitShape } from "@bufbuild/protobuf";

import invariant from 'tiny-invariant'

import { interceptors } from '@repo/rpc-codegen/interceptors'
import { createCallOptions } from '@repo/rpc-codegen/sensitive-call'

import { StudioMediaMatrixService, InitiateSessionResponse, InitiateSessionRequestSchema, IterateSessionResponse, IterateSessionRequestSchema, ListSessionsResponse, ListSessionsRequestSchema, GetSessionResponse, GetSessionRequestSchema, GetSessionIterationsResponse, GetSessionIterationsRequestSchema, DeleteSessionResponse, DeleteSessionRequestSchema, PurgeSessionResponse, PurgeSessionRequestSchema, SetSessionMediaNSFWResponse, SetSessionMediaNSFWRequestSchema, GetSessionMediaResponse, GetSessionMediaRequestSchema, GetSessionInputMediaResponse, GetSessionInputMediaRequestSchema, UpdateSessionResponse, UpdateSessionRequestSchema, CreateShareLinkResponse, CreateShareLinkRequestSchema, ListModelsResponse, ListModelsRequestSchema, FavoriteToolResponse, FavoriteToolRequestSchema, UnfavoriteToolResponse, UnfavoriteToolRequestSchema, ListFavoriteToolsResponse, ListFavoriteToolsRequestSchema } from "@repo/rpc-types-creativefabrica-studiomediamatrix-v1/service";

/**
 * This file contains generated TanStack Query hooks for the gRPC services defined in service.proto
 */

/**
 * Base type for query keys. Query keys are arrays that uniquely identify a query,
 * consisting of a root key constant and optional variables.
 * @template TVariables - The type of variables that can be included in the query key
 */
type QueryKey<TVariables> = (TVariables | string)[];

/**
 * Base type for query options, containing the query key and query function.
 * @template TResult - The expected result type of the query
 * @template TVariables - The variables type for the query
 */
type QueryOptions<TResult, TVariables> = Pick<UseQueryOptions<TResult, Error, TResult, QueryKey<TVariables>>, 'queryKey' | 'queryFn'>;

/**
 * Hooks and utilities for the StudioMediaMatrixService service
 * Service: creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService
 */

let StudioMediaMatrixServiceClient: ReturnType<typeof createClient<typeof StudioMediaMatrixService>> | undefined

function getStudioMediaMatrixServiceClient() {
  const baseUrl = process.env.VITE_RPC_STUDIOMEDIAMATRIX_URL
  invariant(baseUrl, 'VITE_RPC_STUDIOMEDIAMATRIX_URL env var is not set')
  StudioMediaMatrixServiceClient ??= createClient(
    StudioMediaMatrixService,
    createConnectTransport({
      baseUrl,
      useBinaryFormat: false,
      interceptors,
    }),
  )
  return StudioMediaMatrixServiceClient
}

/**
 * Unique identifier for the InitiateSession mutation
 */
export const InitiateSessionMutationKey = 'StudioMediaMatrixService.InitiateSession' as const;

/**
 * @generated from rpc creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.InitiateSession
 */
/**
 * Function to execute the InitiateSession RPC call directly.
 * 
 * This is a low-level function that sends the request to the server and returns a Promise.
 * For most use cases, prefer using the TanStack Query hooks that provide caching and status management.
 * 
 * Use this function when you need direct control over the request and response,
 * such as in server-side code. If you just want to do something on the client side,
 * we still recommend going through the queryClient to ensure consistency.
 * 
 * @param variables - The Input parameters for the RPC call
 * @param meta - Optional meta with sensitive flag for Sentry logging
 * @returns Promise resolving to the response data
 */
export async function initiateSessionFn(variables: MessageInitShape<typeof InitiateSessionRequestSchema>, meta?: Record<string, unknown>): Promise<InitiateSessionResponse> {
  return getStudioMediaMatrixServiceClient().initiateSession(variables, createCallOptions(meta));
}


/**
 * @generated from rpc creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.InitiateSession
 */
export function useInitiateSessionMutation(options?: Omit<
  UseMutationOptions<
    InitiateSessionResponse,
    Error,
    MessageInitShape<typeof InitiateSessionRequestSchema>,
    unknown
  >, 'mutationFn'>) {
  return useMutation<
    InitiateSessionResponse,
    Error,
    MessageInitShape<typeof InitiateSessionRequestSchema>,
    unknown
  >({
    mutationFn: (variables) => initiateSessionFn(variables, options?.meta),
    mutationKey: [InitiateSessionMutationKey],
    ...options,
  });
}

/**
 * Unique identifier for the IterateSession mutation
 */
export const IterateSessionMutationKey = 'StudioMediaMatrixService.IterateSession' as const;

/**
 * @generated from rpc creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.IterateSession
 */
/**
 * Function to execute the IterateSession RPC call directly.
 * 
 * This is a low-level function that sends the request to the server and returns a Promise.
 * For most use cases, prefer using the TanStack Query hooks that provide caching and status management.
 * 
 * Use this function when you need direct control over the request and response,
 * such as in server-side code. If you just want to do something on the client side,
 * we still recommend going through the queryClient to ensure consistency.
 * 
 * @param variables - The Input parameters for the RPC call
 * @param meta - Optional meta with sensitive flag for Sentry logging
 * @returns Promise resolving to the response data
 */
export async function iterateSessionFn(variables: MessageInitShape<typeof IterateSessionRequestSchema>, meta?: Record<string, unknown>): Promise<IterateSessionResponse> {
  return getStudioMediaMatrixServiceClient().iterateSession(variables, createCallOptions(meta));
}


/**
 * @generated from rpc creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.IterateSession
 */
export function useIterateSessionMutation(options?: Omit<
  UseMutationOptions<
    IterateSessionResponse,
    Error,
    MessageInitShape<typeof IterateSessionRequestSchema>,
    unknown
  >, 'mutationFn'>) {
  return useMutation<
    IterateSessionResponse,
    Error,
    MessageInitShape<typeof IterateSessionRequestSchema>,
    unknown
  >({
    mutationFn: (variables) => iterateSessionFn(variables, options?.meta),
    mutationKey: [IterateSessionMutationKey],
    ...options,
  });
}

/**
 * Unique identifier for the ListSessions infinite query
 */
export const ListSessionsQueryRootKey = 'StudioMediaMatrixService.ListSessions' as const;

/**
 * @generated from rpc creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.ListSessions
 */
/**
 * Function to execute the ListSessions RPC call directly.
 * 
 * This is a low-level function that sends the request to the server and returns a Promise.
 * For most use cases, prefer using the TanStack Query hooks that provide caching and status management.
 * 
 * Use this function when you do not need the overhead of TanStack Query,
 * such as in server-side code or outside of React components.
 * 
 * For more patterns, consult the documentation in Confluence.
 * 
 * @param variables - Input parameters for the RPC call
 * @param meta - Optional meta with sensitive flag for Sentry logging
 * @returns Promise resolving to the response data
 */
export async function listSessionsFn(variables: MessageInitShape<typeof ListSessionsRequestSchema>, meta?: Record<string, unknown>) {
  return getStudioMediaMatrixServiceClient().listSessions(variables, createCallOptions(meta));
}

export function useListSessionsInfiniteQuery<D = ListSessionsResponse>(
  variables: MessageInitShape<typeof ListSessionsRequestSchema>,
  options?: Omit<
    UseInfiniteQueryOptions<
      ListSessionsResponse,
      Error,
      InfiniteData<D, string | undefined>,
      string[],
      string | undefined
    >,
    'queryKey' | 'queryFn' | 'initialPageParam' | 'getNextPageParam'
  > & {
    initialPageParam?: string | undefined
  },
) {
  const { pagination, ...otherVariables } = variables
  return useInfiniteQuery({
    queryKey: [ListSessionsQueryRootKey, JSON.stringify(otherVariables)],
    initialPageParam: undefined,
    getNextPageParam: lastPage => lastPage.pagination?.next?.value === "" ? null : lastPage.pagination?.next?.value ?? null,
    queryFn: ({ pageParam, meta }) => {
      const queryOptions: MessageInitShape<typeof ListSessionsRequestSchema> = {
        ...variables,
      }
      if (pagination) {
        queryOptions.pagination = pagination
      }
      if (pageParam) {
        queryOptions.pagination = {
          ...pagination,
          after: {
            '$typeName': 'creativefabrica.common.v1.Cursor',
            value: pageParam
          }
        }
      }
      return listSessionsFn(queryOptions, meta)
    },
    ...options,
  })
}

/**
 * @generated from rpc creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.ListSessions
 */

/**
 * Unique identifier for the GetSession query
 */
export const GetSessionQueryRootKey = 'StudioMediaMatrixService.GetSession' as const;

/**
 * Return type for the GetSession query
 */
type GetSessionQueryResult = GetSessionResponse;

/**
 * Generates a unique query key for the GetSession query with variables.
 * The key includes the root key constant and optional variables.
 * If you don't need variables, you can just import the `GetSessionQueryRootKey`.
 * 
 * Query keys are used by React Query to identify and deduplicate queries.
 * They're also used for cache invalidation and refetching.
 * 
 * @param variables - Optional variables to include in the query key
 * @returns An array that uniquely identifies this query with these variables
 */
export const getSessionQueryKey = /*@__PURE__*/ function getSessionQueryKey(variables?: MessageInitShape<typeof GetSessionRequestSchema>): QueryKey<MessageInitShape<typeof GetSessionRequestSchema>> {
  const key: QueryKey<MessageInitShape<typeof GetSessionRequestSchema>> = [GetSessionQueryRootKey];
  return variables === undefined ? key : [...key, variables];
}

/**
 * GetSession retrieves a session by its ID.
 * Missing the media content in order to avoid unnecessary look up for payloads.
 * If media content is needed, use GetSessionMedia rpc.
 *
 * @generated from rpc creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.GetSession
 */
/**
 * Function to execute the GetSession RPC call directly.
 * 
 * This is a "low-level" function that sends the request to the server and returns a Promise.
 * For most use cases, prefer using the TanStack Query hooks that provide caching and status management.
 * 
 * Use this function when you do not need the overhead of TanStack Query,
 * such as in server-side code or outside of React components.
 * 
 * For more patterns, consult the documentation in Confluence.
 * 
 * @param variables - Input parameters for the RPC call
 * @param meta - Optional meta with sensitive flag for Sentry logging
 * @returns Promise resolving to the response data
 */
export async function getSessionFn(variables: MessageInitShape<typeof GetSessionRequestSchema>, meta?: Record<string, unknown>): Promise<GetSessionResponse> {
  return getStudioMediaMatrixServiceClient().getSession(variables, createCallOptions(meta));
}

/**
 * Creates React Query options for the GetSession query.
 * 
 * This function generates an options object that includes:
 * 1. A unique query key for React Query's cache management
 * 2. A query function that makes the actual RPC call
 * 
 * You should use this function when you need to:
 * - Prefetch data before navigation
 * - Create a query for manual execution with queryClient
 * 
 * For example: 
 * ```ts
 * const options = getSessionQueryOptions({
 *   some: 'value',
 * });
 * 
 * queryClient.prefetchQuery(options);
 * 
 * // or
 * useQueries({
 *   queries: [options]
 * });
 * 
 * ```
 * 
 * See more of this pattern at https://tkdodo.eu/blog/the-query-options-api
 * 
 * For most cases, use the useGetSessionQuery hook directly instead.
 * 
 * @param variables - Input parameters for the RPC call
 */
export const getSessionQueryOptions = /*@__PURE__*/ function(variables: MessageInitShape<typeof GetSessionRequestSchema>): QueryOptions<GetSessionQueryResult, MessageInitShape<typeof GetSessionRequestSchema>> {
  return {
    queryKey: getSessionQueryKey(variables),
    queryFn: async (context) => getSessionFn(variables, context.meta)
  };
};


/**
 * GetSession retrieves a session by its ID.
 * Missing the media content in order to avoid unnecessary look up for payloads.
 * If media content is needed, use GetSessionMedia rpc.
 *
 * @generated from rpc creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.GetSession
 */
export function useGetSessionQuery<D = GetSessionQueryResult, E = Error>(variables: MessageInitShape<typeof GetSessionRequestSchema>, options?: Omit<
  UseQueryOptions<
    GetSessionQueryResult,
    E,
    D,
    QueryKey<MessageInitShape<typeof GetSessionRequestSchema>>
  >, 'queryKey' | 'queryFn'>) {
  return useQuery<
    GetSessionQueryResult,
    E,
    D,
    QueryKey<MessageInitShape<typeof GetSessionRequestSchema>>
  >({
    ...options,
    ...getSessionQueryOptions(variables),
  });
}

/**
 * Unique identifier for the GetSessionIterations infinite query
 */
export const GetSessionIterationsQueryRootKey = 'StudioMediaMatrixService.GetSessionIterations' as const;

/**
 * @generated from rpc creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.GetSessionIterations
 */
/**
 * Function to execute the GetSessionIterations RPC call directly.
 * 
 * This is a low-level function that sends the request to the server and returns a Promise.
 * For most use cases, prefer using the TanStack Query hooks that provide caching and status management.
 * 
 * Use this function when you do not need the overhead of TanStack Query,
 * such as in server-side code or outside of React components.
 * 
 * For more patterns, consult the documentation in Confluence.
 * 
 * @param variables - Input parameters for the RPC call
 * @param meta - Optional meta with sensitive flag for Sentry logging
 * @returns Promise resolving to the response data
 */
export async function getSessionIterationsFn(variables: MessageInitShape<typeof GetSessionIterationsRequestSchema>, meta?: Record<string, unknown>) {
  return getStudioMediaMatrixServiceClient().getSessionIterations(variables, createCallOptions(meta));
}

export function useGetSessionIterationsInfiniteQuery<D = GetSessionIterationsResponse>(
  variables: MessageInitShape<typeof GetSessionIterationsRequestSchema>,
  options?: Omit<
    UseInfiniteQueryOptions<
      GetSessionIterationsResponse,
      Error,
      InfiniteData<D, string | undefined>,
      string[],
      string | undefined
    >,
    'queryKey' | 'queryFn' | 'initialPageParam' | 'getNextPageParam'
  > & {
    initialPageParam?: string | undefined
  },
) {
  const { pagination, ...otherVariables } = variables
  return useInfiniteQuery({
    queryKey: [GetSessionIterationsQueryRootKey, JSON.stringify(otherVariables)],
    initialPageParam: undefined,
    getNextPageParam: lastPage => lastPage.pagination?.next?.value === "" ? null : lastPage.pagination?.next?.value ?? null,
    queryFn: ({ pageParam, meta }) => {
      const queryOptions: MessageInitShape<typeof GetSessionIterationsRequestSchema> = {
        ...variables,
      }
      if (pagination) {
        queryOptions.pagination = pagination
      }
      if (pageParam) {
        queryOptions.pagination = {
          ...pagination,
          after: {
            '$typeName': 'creativefabrica.common.v1.Cursor',
            value: pageParam
          }
        }
      }
      return getSessionIterationsFn(queryOptions, meta)
    },
    ...options,
  })
}

/**
 * @generated from rpc creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.GetSessionIterations
 */

/**
 * Unique identifier for the DeleteSession mutation
 */
export const DeleteSessionMutationKey = 'StudioMediaMatrixService.DeleteSession' as const;

/**
 * @generated from rpc creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.DeleteSession
 */
/**
 * Function to execute the DeleteSession RPC call directly.
 * 
 * This is a low-level function that sends the request to the server and returns a Promise.
 * For most use cases, prefer using the TanStack Query hooks that provide caching and status management.
 * 
 * Use this function when you need direct control over the request and response,
 * such as in server-side code. If you just want to do something on the client side,
 * we still recommend going through the queryClient to ensure consistency.
 * 
 * @param variables - The Input parameters for the RPC call
 * @param meta - Optional meta with sensitive flag for Sentry logging
 * @returns Promise resolving to the response data
 */
export async function deleteSessionFn(variables: MessageInitShape<typeof DeleteSessionRequestSchema>, meta?: Record<string, unknown>): Promise<DeleteSessionResponse> {
  return getStudioMediaMatrixServiceClient().deleteSession(variables, createCallOptions(meta));
}


/**
 * @generated from rpc creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.DeleteSession
 */
export function useDeleteSessionMutation(options?: Omit<
  UseMutationOptions<
    DeleteSessionResponse,
    Error,
    MessageInitShape<typeof DeleteSessionRequestSchema>,
    unknown
  >, 'mutationFn'>) {
  return useMutation<
    DeleteSessionResponse,
    Error,
    MessageInitShape<typeof DeleteSessionRequestSchema>,
    unknown
  >({
    mutationFn: (variables) => deleteSessionFn(variables, options?.meta),
    mutationKey: [DeleteSessionMutationKey],
    ...options,
  });
}

/**
 * Unique identifier for the PurgeSession mutation
 */
export const PurgeSessionMutationKey = 'StudioMediaMatrixService.PurgeSession' as const;

/**
 * PurgeSession is a Creative Fabrica staff-only takedown: it marks the session
 * private, soft-deletes it, deletes its S3 input/output media, and invalidates
 * the VOD CloudFront cache for the removed objects. Authorization is enforced by
 * the service (caller's email must be @creativefabrica.com).
 *
 * @generated from rpc creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.PurgeSession
 */
/**
 * Function to execute the PurgeSession RPC call directly.
 * 
 * This is a low-level function that sends the request to the server and returns a Promise.
 * For most use cases, prefer using the TanStack Query hooks that provide caching and status management.
 * 
 * Use this function when you need direct control over the request and response,
 * such as in server-side code. If you just want to do something on the client side,
 * we still recommend going through the queryClient to ensure consistency.
 * 
 * @param variables - The Input parameters for the RPC call
 * @param meta - Optional meta with sensitive flag for Sentry logging
 * @returns Promise resolving to the response data
 */
export async function purgeSessionFn(variables: MessageInitShape<typeof PurgeSessionRequestSchema>, meta?: Record<string, unknown>): Promise<PurgeSessionResponse> {
  return getStudioMediaMatrixServiceClient().purgeSession(variables, createCallOptions(meta));
}


/**
 * PurgeSession is a Creative Fabrica staff-only takedown: it marks the session
 * private, soft-deletes it, deletes its S3 input/output media, and invalidates
 * the VOD CloudFront cache for the removed objects. Authorization is enforced by
 * the service (caller's email must be @creativefabrica.com).
 *
 * @generated from rpc creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.PurgeSession
 */
export function usePurgeSessionMutation(options?: Omit<
  UseMutationOptions<
    PurgeSessionResponse,
    Error,
    MessageInitShape<typeof PurgeSessionRequestSchema>,
    unknown
  >, 'mutationFn'>) {
  return useMutation<
    PurgeSessionResponse,
    Error,
    MessageInitShape<typeof PurgeSessionRequestSchema>,
    unknown
  >({
    mutationFn: (variables) => purgeSessionFn(variables, options?.meta),
    mutationKey: [PurgeSessionMutationKey],
    ...options,
  });
}

/**
 * Unique identifier for the SetSessionMediaNSFW mutation
 */
export const SetSessionMediaNSFWMutationKey = 'StudioMediaMatrixService.SetSessionMediaNSFW' as const;

/**
 * SetSessionMediaNSFW is a Creative Fabrica staff-only moderation action: it
 * sets or clears the NSFW flag on the session's output media — images and
 * video media items (other media types have no NSFW flag) — and returns the
 * session's output media after the update. It does not change the session's
 * visibility. Authorization is enforced by the service (caller's email must
 * be @creativefabrica.com).
 *
 * @generated from rpc creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.SetSessionMediaNSFW
 */
/**
 * Function to execute the SetSessionMediaNSFW RPC call directly.
 * 
 * This is a low-level function that sends the request to the server and returns a Promise.
 * For most use cases, prefer using the TanStack Query hooks that provide caching and status management.
 * 
 * Use this function when you need direct control over the request and response,
 * such as in server-side code. If you just want to do something on the client side,
 * we still recommend going through the queryClient to ensure consistency.
 * 
 * @param variables - The Input parameters for the RPC call
 * @param meta - Optional meta with sensitive flag for Sentry logging
 * @returns Promise resolving to the response data
 */
export async function setSessionMediaNSFWFn(variables: MessageInitShape<typeof SetSessionMediaNSFWRequestSchema>, meta?: Record<string, unknown>): Promise<SetSessionMediaNSFWResponse> {
  return getStudioMediaMatrixServiceClient().setSessionMediaNSFW(variables, createCallOptions(meta));
}


/**
 * SetSessionMediaNSFW is a Creative Fabrica staff-only moderation action: it
 * sets or clears the NSFW flag on the session's output media — images and
 * video media items (other media types have no NSFW flag) — and returns the
 * session's output media after the update. It does not change the session's
 * visibility. Authorization is enforced by the service (caller's email must
 * be @creativefabrica.com).
 *
 * @generated from rpc creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.SetSessionMediaNSFW
 */
export function useSetSessionMediaNSFWMutation(options?: Omit<
  UseMutationOptions<
    SetSessionMediaNSFWResponse,
    Error,
    MessageInitShape<typeof SetSessionMediaNSFWRequestSchema>,
    unknown
  >, 'mutationFn'>) {
  return useMutation<
    SetSessionMediaNSFWResponse,
    Error,
    MessageInitShape<typeof SetSessionMediaNSFWRequestSchema>,
    unknown
  >({
    mutationFn: (variables) => setSessionMediaNSFWFn(variables, options?.meta),
    mutationKey: [SetSessionMediaNSFWMutationKey],
    ...options,
  });
}

/**
 * Unique identifier for the GetSessionMedia query
 */
export const GetSessionMediaQueryRootKey = 'StudioMediaMatrixService.GetSessionMedia' as const;

/**
 * Return type for the GetSessionMedia query
 */
type GetSessionMediaQueryResult = GetSessionMediaResponse;

/**
 * Generates a unique query key for the GetSessionMedia query with variables.
 * The key includes the root key constant and optional variables.
 * If you don't need variables, you can just import the `GetSessionMediaQueryRootKey`.
 * 
 * Query keys are used by React Query to identify and deduplicate queries.
 * They're also used for cache invalidation and refetching.
 * 
 * @param variables - Optional variables to include in the query key
 * @returns An array that uniquely identifies this query with these variables
 */
export const getSessionMediaQueryKey = /*@__PURE__*/ function getSessionMediaQueryKey(variables?: MessageInitShape<typeof GetSessionMediaRequestSchema>): QueryKey<MessageInitShape<typeof GetSessionMediaRequestSchema>> {
  const key: QueryKey<MessageInitShape<typeof GetSessionMediaRequestSchema>> = [GetSessionMediaQueryRootKey];
  return variables === undefined ? key : [...key, variables];
}

/**
 * @generated from rpc creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.GetSessionMedia
 */
/**
 * Function to execute the GetSessionMedia RPC call directly.
 * 
 * This is a "low-level" function that sends the request to the server and returns a Promise.
 * For most use cases, prefer using the TanStack Query hooks that provide caching and status management.
 * 
 * Use this function when you do not need the overhead of TanStack Query,
 * such as in server-side code or outside of React components.
 * 
 * For more patterns, consult the documentation in Confluence.
 * 
 * @param variables - Input parameters for the RPC call
 * @param meta - Optional meta with sensitive flag for Sentry logging
 * @returns Promise resolving to the response data
 */
export async function getSessionMediaFn(variables: MessageInitShape<typeof GetSessionMediaRequestSchema>, meta?: Record<string, unknown>): Promise<GetSessionMediaResponse> {
  return getStudioMediaMatrixServiceClient().getSessionMedia(variables, createCallOptions(meta));
}

/**
 * Creates React Query options for the GetSessionMedia query.
 * 
 * This function generates an options object that includes:
 * 1. A unique query key for React Query's cache management
 * 2. A query function that makes the actual RPC call
 * 
 * You should use this function when you need to:
 * - Prefetch data before navigation
 * - Create a query for manual execution with queryClient
 * 
 * For example: 
 * ```ts
 * const options = getSessionMediaQueryOptions({
 *   some: 'value',
 * });
 * 
 * queryClient.prefetchQuery(options);
 * 
 * // or
 * useQueries({
 *   queries: [options]
 * });
 * 
 * ```
 * 
 * See more of this pattern at https://tkdodo.eu/blog/the-query-options-api
 * 
 * For most cases, use the useGetSessionMediaQuery hook directly instead.
 * 
 * @param variables - Input parameters for the RPC call
 */
export const getSessionMediaQueryOptions = /*@__PURE__*/ function(variables: MessageInitShape<typeof GetSessionMediaRequestSchema>): QueryOptions<GetSessionMediaQueryResult, MessageInitShape<typeof GetSessionMediaRequestSchema>> {
  return {
    queryKey: getSessionMediaQueryKey(variables),
    queryFn: async (context) => getSessionMediaFn(variables, context.meta)
  };
};


/**
 * @generated from rpc creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.GetSessionMedia
 */
export function useGetSessionMediaQuery<D = GetSessionMediaQueryResult, E = Error>(variables: MessageInitShape<typeof GetSessionMediaRequestSchema>, options?: Omit<
  UseQueryOptions<
    GetSessionMediaQueryResult,
    E,
    D,
    QueryKey<MessageInitShape<typeof GetSessionMediaRequestSchema>>
  >, 'queryKey' | 'queryFn'>) {
  return useQuery<
    GetSessionMediaQueryResult,
    E,
    D,
    QueryKey<MessageInitShape<typeof GetSessionMediaRequestSchema>>
  >({
    ...options,
    ...getSessionMediaQueryOptions(variables),
  });
}

/**
 * Unique identifier for the GetSessionInputMedia query
 */
export const GetSessionInputMediaQueryRootKey = 'StudioMediaMatrixService.GetSessionInputMedia' as const;

/**
 * Return type for the GetSessionInputMedia query
 */
type GetSessionInputMediaQueryResult = GetSessionInputMediaResponse;

/**
 * Generates a unique query key for the GetSessionInputMedia query with variables.
 * The key includes the root key constant and optional variables.
 * If you don't need variables, you can just import the `GetSessionInputMediaQueryRootKey`.
 * 
 * Query keys are used by React Query to identify and deduplicate queries.
 * They're also used for cache invalidation and refetching.
 * 
 * @param variables - Optional variables to include in the query key
 * @returns An array that uniquely identifies this query with these variables
 */
export const getSessionInputMediaQueryKey = /*@__PURE__*/ function getSessionInputMediaQueryKey(variables?: MessageInitShape<typeof GetSessionInputMediaRequestSchema>): QueryKey<MessageInitShape<typeof GetSessionInputMediaRequestSchema>> {
  const key: QueryKey<MessageInitShape<typeof GetSessionInputMediaRequestSchema>> = [GetSessionInputMediaQueryRootKey];
  return variables === undefined ? key : [...key, variables];
}

/**
 * @generated from rpc creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.GetSessionInputMedia
 */
/**
 * Function to execute the GetSessionInputMedia RPC call directly.
 * 
 * This is a "low-level" function that sends the request to the server and returns a Promise.
 * For most use cases, prefer using the TanStack Query hooks that provide caching and status management.
 * 
 * Use this function when you do not need the overhead of TanStack Query,
 * such as in server-side code or outside of React components.
 * 
 * For more patterns, consult the documentation in Confluence.
 * 
 * @param variables - Input parameters for the RPC call
 * @param meta - Optional meta with sensitive flag for Sentry logging
 * @returns Promise resolving to the response data
 */
export async function getSessionInputMediaFn(variables: MessageInitShape<typeof GetSessionInputMediaRequestSchema>, meta?: Record<string, unknown>): Promise<GetSessionInputMediaResponse> {
  return getStudioMediaMatrixServiceClient().getSessionInputMedia(variables, createCallOptions(meta));
}

/**
 * Creates React Query options for the GetSessionInputMedia query.
 * 
 * This function generates an options object that includes:
 * 1. A unique query key for React Query's cache management
 * 2. A query function that makes the actual RPC call
 * 
 * You should use this function when you need to:
 * - Prefetch data before navigation
 * - Create a query for manual execution with queryClient
 * 
 * For example: 
 * ```ts
 * const options = getSessionInputMediaQueryOptions({
 *   some: 'value',
 * });
 * 
 * queryClient.prefetchQuery(options);
 * 
 * // or
 * useQueries({
 *   queries: [options]
 * });
 * 
 * ```
 * 
 * See more of this pattern at https://tkdodo.eu/blog/the-query-options-api
 * 
 * For most cases, use the useGetSessionInputMediaQuery hook directly instead.
 * 
 * @param variables - Input parameters for the RPC call
 */
export const getSessionInputMediaQueryOptions = /*@__PURE__*/ function(variables: MessageInitShape<typeof GetSessionInputMediaRequestSchema>): QueryOptions<GetSessionInputMediaQueryResult, MessageInitShape<typeof GetSessionInputMediaRequestSchema>> {
  return {
    queryKey: getSessionInputMediaQueryKey(variables),
    queryFn: async (context) => getSessionInputMediaFn(variables, context.meta)
  };
};


/**
 * @generated from rpc creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.GetSessionInputMedia
 */
export function useGetSessionInputMediaQuery<D = GetSessionInputMediaQueryResult, E = Error>(variables: MessageInitShape<typeof GetSessionInputMediaRequestSchema>, options?: Omit<
  UseQueryOptions<
    GetSessionInputMediaQueryResult,
    E,
    D,
    QueryKey<MessageInitShape<typeof GetSessionInputMediaRequestSchema>>
  >, 'queryKey' | 'queryFn'>) {
  return useQuery<
    GetSessionInputMediaQueryResult,
    E,
    D,
    QueryKey<MessageInitShape<typeof GetSessionInputMediaRequestSchema>>
  >({
    ...options,
    ...getSessionInputMediaQueryOptions(variables),
  });
}

/**
 * Unique identifier for the UpdateSession mutation
 */
export const UpdateSessionMutationKey = 'StudioMediaMatrixService.UpdateSession' as const;

/**
 * @generated from rpc creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.UpdateSession
 */
/**
 * Function to execute the UpdateSession RPC call directly.
 * 
 * This is a low-level function that sends the request to the server and returns a Promise.
 * For most use cases, prefer using the TanStack Query hooks that provide caching and status management.
 * 
 * Use this function when you need direct control over the request and response,
 * such as in server-side code. If you just want to do something on the client side,
 * we still recommend going through the queryClient to ensure consistency.
 * 
 * @param variables - The Input parameters for the RPC call
 * @param meta - Optional meta with sensitive flag for Sentry logging
 * @returns Promise resolving to the response data
 */
export async function updateSessionFn(variables: MessageInitShape<typeof UpdateSessionRequestSchema>, meta?: Record<string, unknown>): Promise<UpdateSessionResponse> {
  return getStudioMediaMatrixServiceClient().updateSession(variables, createCallOptions(meta));
}


/**
 * @generated from rpc creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.UpdateSession
 */
export function useUpdateSessionMutation(options?: Omit<
  UseMutationOptions<
    UpdateSessionResponse,
    Error,
    MessageInitShape<typeof UpdateSessionRequestSchema>,
    unknown
  >, 'mutationFn'>) {
  return useMutation<
    UpdateSessionResponse,
    Error,
    MessageInitShape<typeof UpdateSessionRequestSchema>,
    unknown
  >({
    mutationFn: (variables) => updateSessionFn(variables, options?.meta),
    mutationKey: [UpdateSessionMutationKey],
    ...options,
  });
}

/**
 * Unique identifier for the CreateShareLink mutation
 */
export const CreateShareLinkMutationKey = 'StudioMediaMatrixService.CreateShareLink' as const;

/**
 * @generated from rpc creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.CreateShareLink
 */
/**
 * Function to execute the CreateShareLink RPC call directly.
 * 
 * This is a low-level function that sends the request to the server and returns a Promise.
 * For most use cases, prefer using the TanStack Query hooks that provide caching and status management.
 * 
 * Use this function when you need direct control over the request and response,
 * such as in server-side code. If you just want to do something on the client side,
 * we still recommend going through the queryClient to ensure consistency.
 * 
 * @param variables - The Input parameters for the RPC call
 * @param meta - Optional meta with sensitive flag for Sentry logging
 * @returns Promise resolving to the response data
 */
export async function createShareLinkFn(variables: MessageInitShape<typeof CreateShareLinkRequestSchema>, meta?: Record<string, unknown>): Promise<CreateShareLinkResponse> {
  return getStudioMediaMatrixServiceClient().createShareLink(variables, createCallOptions(meta));
}


/**
 * @generated from rpc creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.CreateShareLink
 */
export function useCreateShareLinkMutation(options?: Omit<
  UseMutationOptions<
    CreateShareLinkResponse,
    Error,
    MessageInitShape<typeof CreateShareLinkRequestSchema>,
    unknown
  >, 'mutationFn'>) {
  return useMutation<
    CreateShareLinkResponse,
    Error,
    MessageInitShape<typeof CreateShareLinkRequestSchema>,
    unknown
  >({
    mutationFn: (variables) => createShareLinkFn(variables, options?.meta),
    mutationKey: [CreateShareLinkMutationKey],
    ...options,
  });
}

/**
 * Unique identifier for the ListModels query
 */
export const ListModelsQueryRootKey = 'StudioMediaMatrixService.ListModels' as const;

/**
 * Return type for the ListModels query
 */
type ListModelsQueryResult = ListModelsResponse;

/**
 * Generates a unique query key for the ListModels query with variables.
 * The key includes the root key constant and optional variables.
 * If you don't need variables, you can just import the `ListModelsQueryRootKey`.
 * 
 * Query keys are used by React Query to identify and deduplicate queries.
 * They're also used for cache invalidation and refetching.
 * 
 * @param variables - Optional variables to include in the query key
 * @returns An array that uniquely identifies this query with these variables
 */
export const listModelsQueryKey = /*@__PURE__*/ function listModelsQueryKey(variables?: MessageInitShape<typeof ListModelsRequestSchema>): QueryKey<MessageInitShape<typeof ListModelsRequestSchema>> {
  const key: QueryKey<MessageInitShape<typeof ListModelsRequestSchema>> = [ListModelsQueryRootKey];
  return variables === undefined ? key : [...key, variables];
}

/**
 * ListModels lists the models available for one app (service_type) with
 * display metadata and capabilities sourced from services-genai's
 * AIProviderService catalog. SERVICE_TYPE_VIDEO_GENERATOR,
 * SERVICE_TYPE_VIDEO_EDITOR, SERVICE_TYPE_IMAGE_EDITOR and
 * SERVICE_TYPE_YOUTUBE_THUMBNAIL_GENERATOR are supported;
 * any other service_type fails with INVALID_ARGUMENT.
 *
 * @generated from rpc creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.ListModels
 */
/**
 * Function to execute the ListModels RPC call directly.
 * 
 * This is a "low-level" function that sends the request to the server and returns a Promise.
 * For most use cases, prefer using the TanStack Query hooks that provide caching and status management.
 * 
 * Use this function when you do not need the overhead of TanStack Query,
 * such as in server-side code or outside of React components.
 * 
 * For more patterns, consult the documentation in Confluence.
 * 
 * @param variables - Input parameters for the RPC call
 * @param meta - Optional meta with sensitive flag for Sentry logging
 * @returns Promise resolving to the response data
 */
export async function listModelsFn(variables: MessageInitShape<typeof ListModelsRequestSchema>, meta?: Record<string, unknown>): Promise<ListModelsResponse> {
  return getStudioMediaMatrixServiceClient().listModels(variables, createCallOptions(meta));
}

/**
 * Creates React Query options for the ListModels query.
 * 
 * This function generates an options object that includes:
 * 1. A unique query key for React Query's cache management
 * 2. A query function that makes the actual RPC call
 * 
 * You should use this function when you need to:
 * - Prefetch data before navigation
 * - Create a query for manual execution with queryClient
 * 
 * For example: 
 * ```ts
 * const options = listModelsQueryOptions({
 *   some: 'value',
 * });
 * 
 * queryClient.prefetchQuery(options);
 * 
 * // or
 * useQueries({
 *   queries: [options]
 * });
 * 
 * ```
 * 
 * See more of this pattern at https://tkdodo.eu/blog/the-query-options-api
 * 
 * For most cases, use the useListModelsQuery hook directly instead.
 * 
 * @param variables - Input parameters for the RPC call
 */
export const listModelsQueryOptions = /*@__PURE__*/ function(variables: MessageInitShape<typeof ListModelsRequestSchema>): QueryOptions<ListModelsQueryResult, MessageInitShape<typeof ListModelsRequestSchema>> {
  return {
    queryKey: listModelsQueryKey(variables),
    queryFn: async (context) => listModelsFn(variables, context.meta)
  };
};


/**
 * ListModels lists the models available for one app (service_type) with
 * display metadata and capabilities sourced from services-genai's
 * AIProviderService catalog. SERVICE_TYPE_VIDEO_GENERATOR,
 * SERVICE_TYPE_VIDEO_EDITOR, SERVICE_TYPE_IMAGE_EDITOR and
 * SERVICE_TYPE_YOUTUBE_THUMBNAIL_GENERATOR are supported;
 * any other service_type fails with INVALID_ARGUMENT.
 *
 * @generated from rpc creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.ListModels
 */
export function useListModelsQuery<D = ListModelsQueryResult, E = Error>(variables: MessageInitShape<typeof ListModelsRequestSchema>, options?: Omit<
  UseQueryOptions<
    ListModelsQueryResult,
    E,
    D,
    QueryKey<MessageInitShape<typeof ListModelsRequestSchema>>
  >, 'queryKey' | 'queryFn'>) {
  return useQuery<
    ListModelsQueryResult,
    E,
    D,
    QueryKey<MessageInitShape<typeof ListModelsRequestSchema>>
  >({
    ...options,
    ...listModelsQueryOptions(variables),
  });
}

/**
 * Unique identifier for the FavoriteTool mutation
 */
export const FavoriteToolMutationKey = 'StudioMediaMatrixService.FavoriteTool' as const;

/**
 * @generated from rpc creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.FavoriteTool
 */
/**
 * Function to execute the FavoriteTool RPC call directly.
 * 
 * This is a low-level function that sends the request to the server and returns a Promise.
 * For most use cases, prefer using the TanStack Query hooks that provide caching and status management.
 * 
 * Use this function when you need direct control over the request and response,
 * such as in server-side code. If you just want to do something on the client side,
 * we still recommend going through the queryClient to ensure consistency.
 * 
 * @param variables - The Input parameters for the RPC call
 * @param meta - Optional meta with sensitive flag for Sentry logging
 * @returns Promise resolving to the response data
 */
export async function favoriteToolFn(variables: MessageInitShape<typeof FavoriteToolRequestSchema>, meta?: Record<string, unknown>): Promise<FavoriteToolResponse> {
  return getStudioMediaMatrixServiceClient().favoriteTool(variables, createCallOptions(meta));
}


/**
 * @generated from rpc creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.FavoriteTool
 */
export function useFavoriteToolMutation(options?: Omit<
  UseMutationOptions<
    FavoriteToolResponse,
    Error,
    MessageInitShape<typeof FavoriteToolRequestSchema>,
    unknown
  >, 'mutationFn'>) {
  return useMutation<
    FavoriteToolResponse,
    Error,
    MessageInitShape<typeof FavoriteToolRequestSchema>,
    unknown
  >({
    mutationFn: (variables) => favoriteToolFn(variables, options?.meta),
    mutationKey: [FavoriteToolMutationKey],
    ...options,
  });
}

/**
 * Unique identifier for the UnfavoriteTool mutation
 */
export const UnfavoriteToolMutationKey = 'StudioMediaMatrixService.UnfavoriteTool' as const;

/**
 * @generated from rpc creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.UnfavoriteTool
 */
/**
 * Function to execute the UnfavoriteTool RPC call directly.
 * 
 * This is a low-level function that sends the request to the server and returns a Promise.
 * For most use cases, prefer using the TanStack Query hooks that provide caching and status management.
 * 
 * Use this function when you need direct control over the request and response,
 * such as in server-side code. If you just want to do something on the client side,
 * we still recommend going through the queryClient to ensure consistency.
 * 
 * @param variables - The Input parameters for the RPC call
 * @param meta - Optional meta with sensitive flag for Sentry logging
 * @returns Promise resolving to the response data
 */
export async function unfavoriteToolFn(variables: MessageInitShape<typeof UnfavoriteToolRequestSchema>, meta?: Record<string, unknown>): Promise<UnfavoriteToolResponse> {
  return getStudioMediaMatrixServiceClient().unfavoriteTool(variables, createCallOptions(meta));
}


/**
 * @generated from rpc creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.UnfavoriteTool
 */
export function useUnfavoriteToolMutation(options?: Omit<
  UseMutationOptions<
    UnfavoriteToolResponse,
    Error,
    MessageInitShape<typeof UnfavoriteToolRequestSchema>,
    unknown
  >, 'mutationFn'>) {
  return useMutation<
    UnfavoriteToolResponse,
    Error,
    MessageInitShape<typeof UnfavoriteToolRequestSchema>,
    unknown
  >({
    mutationFn: (variables) => unfavoriteToolFn(variables, options?.meta),
    mutationKey: [UnfavoriteToolMutationKey],
    ...options,
  });
}

/**
 * Unique identifier for the ListFavoriteTools query
 */
export const ListFavoriteToolsQueryRootKey = 'StudioMediaMatrixService.ListFavoriteTools' as const;

/**
 * Return type for the ListFavoriteTools query
 */
type ListFavoriteToolsQueryResult = ListFavoriteToolsResponse;

/**
 * Generates a unique query key for the ListFavoriteTools query with variables.
 * The key includes the root key constant and optional variables.
 * If you don't need variables, you can just import the `ListFavoriteToolsQueryRootKey`.
 * 
 * Query keys are used by React Query to identify and deduplicate queries.
 * They're also used for cache invalidation and refetching.
 * 
 * @param variables - Optional variables to include in the query key
 * @returns An array that uniquely identifies this query with these variables
 */
export const listFavoriteToolsQueryKey = /*@__PURE__*/ function listFavoriteToolsQueryKey(variables?: MessageInitShape<typeof ListFavoriteToolsRequestSchema>): QueryKey<MessageInitShape<typeof ListFavoriteToolsRequestSchema>> {
  const key: QueryKey<MessageInitShape<typeof ListFavoriteToolsRequestSchema>> = [ListFavoriteToolsQueryRootKey];
  return variables === undefined ? key : [...key, variables];
}

/**
 * @generated from rpc creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.ListFavoriteTools
 */
/**
 * Function to execute the ListFavoriteTools RPC call directly.
 * 
 * This is a "low-level" function that sends the request to the server and returns a Promise.
 * For most use cases, prefer using the TanStack Query hooks that provide caching and status management.
 * 
 * Use this function when you do not need the overhead of TanStack Query,
 * such as in server-side code or outside of React components.
 * 
 * For more patterns, consult the documentation in Confluence.
 * 
 * @param variables - Input parameters for the RPC call
 * @param meta - Optional meta with sensitive flag for Sentry logging
 * @returns Promise resolving to the response data
 */
export async function listFavoriteToolsFn(variables: MessageInitShape<typeof ListFavoriteToolsRequestSchema>, meta?: Record<string, unknown>): Promise<ListFavoriteToolsResponse> {
  return getStudioMediaMatrixServiceClient().listFavoriteTools(variables, createCallOptions(meta));
}

/**
 * Creates React Query options for the ListFavoriteTools query.
 * 
 * This function generates an options object that includes:
 * 1. A unique query key for React Query's cache management
 * 2. A query function that makes the actual RPC call
 * 
 * You should use this function when you need to:
 * - Prefetch data before navigation
 * - Create a query for manual execution with queryClient
 * 
 * For example: 
 * ```ts
 * const options = listFavoriteToolsQueryOptions({
 *   some: 'value',
 * });
 * 
 * queryClient.prefetchQuery(options);
 * 
 * // or
 * useQueries({
 *   queries: [options]
 * });
 * 
 * ```
 * 
 * See more of this pattern at https://tkdodo.eu/blog/the-query-options-api
 * 
 * For most cases, use the useListFavoriteToolsQuery hook directly instead.
 * 
 * @param variables - Input parameters for the RPC call
 */
export const listFavoriteToolsQueryOptions = /*@__PURE__*/ function(variables: MessageInitShape<typeof ListFavoriteToolsRequestSchema>): QueryOptions<ListFavoriteToolsQueryResult, MessageInitShape<typeof ListFavoriteToolsRequestSchema>> {
  return {
    queryKey: listFavoriteToolsQueryKey(variables),
    queryFn: async (context) => listFavoriteToolsFn(variables, context.meta)
  };
};


/**
 * @generated from rpc creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.ListFavoriteTools
 */
export function useListFavoriteToolsQuery<D = ListFavoriteToolsQueryResult, E = Error>(variables: MessageInitShape<typeof ListFavoriteToolsRequestSchema>, options?: Omit<
  UseQueryOptions<
    ListFavoriteToolsQueryResult,
    E,
    D,
    QueryKey<MessageInitShape<typeof ListFavoriteToolsRequestSchema>>
  >, 'queryKey' | 'queryFn'>) {
  return useQuery<
    ListFavoriteToolsQueryResult,
    E,
    D,
    QueryKey<MessageInitShape<typeof ListFavoriteToolsRequestSchema>>
  >({
    ...options,
    ...listFavoriteToolsQueryOptions(variables),
  });
}


